import React, { useEffect, useState } from "react";
import { propsHeaders } from "../../../../services/player/SportService.tsx";
import { getFixtures } from "../../../../services/player/apis/Schelude.tsx";
import { Schedule } from "../../../../models/Schedule.tsx";
import { propsSports } from "../../../../models/Sport.tsx";
import { formatDateTime } from "../../../../helpers/functions.tsx";
import { IoIosArrowForward } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import "../../../../styles/Navigation.css";
import "../../../../styles/Props.css";
import "../../../../styles/Sports.css";
import { isUpcomingPropsGame } from "../../../../helpers/scheduleDateRange.ts";
import LeaguePropsSkeleton, { LeaguePropsTabsSkeleton } from "./LeaguePropsSkeleton.tsx";
import { useBetContext } from "../../../../context/BetContext.tsx";
import { useModal } from "../../../../context/ModalContext.tsx";
import PropsBetSlip from "../../modals/props/PropsBetSlip.tsx";
import AlertError from "../../../alerts/AlertError.tsx";

function LegueProps() {
    const [leagues, setLeagues] = useState<propsSports[]>([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [fixtures, setFixtures] = useState<Schedule[]>([]);
    const [fixturesCache, setFixturesCache] = useState<Record<string, Schedule[]>>({});
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const [hasLoaded, setHasLoaded] = useState(false);
    const { bets } = useBetContext();
    const { showModal } = useModal();
    const [errorMessage, setErrorMessage] = useState("");
    const [showLimitAlert, setShowLimitAlert] = useState(false);

    useEffect(() => {
        document.documentElement.classList.add("props-league-html");
        document.body.classList.add("props-league-body");
        return () => {
            document.documentElement.classList.remove("props-league-html");
            document.body.classList.remove("props-league-body");
        };
    }, []);

    useEffect(() => {
        const loadSports = async () => {
            try {
                const headers = await propsHeaders();
                setLeagues(headers);
                if (headers.length === 0) setIsLoading(false);
            } catch {
                setIsLoading(false);
            }
        };
        loadSports();
    }, []);


    useEffect(() => {
        if (leagues.length === 0) return;
        handleLeagueClick(leagues[0], 0);
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [leagues]);

    const handleLeagueClick = async (item: propsSports, index: number) => {
        const key = `${item.sport}-${item.league}`;
        setActiveIndex(index);
        setHasLoaded(false);

        if (fixturesCache[key]?.some(game => isUpcomingPropsGame(game))) {
            setFixtures(fixturesCache[key].filter(game => isUpcomingPropsGame(game)));
            setHasLoaded(true);
            return;
        }

        try {
            setIsLoading(true);
            const data = await getFixtures({ sport: item.sport, league: item.league });

            setFixtures(data);
            setFixturesCache(prev => ({
                ...prev,
                [key]: data
            }));
            setHasLoaded(true);
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <div className="player-layout player-main-surface props-league-page">
            <div className="props-league-header-container">
                <div className="props-league-topbar">
                    <button
                        type="button"
                        className="props-league-back"
                        onClick={() => navigate(-1)}
                        aria-label="Back"
                    >
                        <IoIosArrowBack />
                    </button>
                    <span className="props-league-title teko">Prop Betting</span>
                    {bets.length > 0 && (
                        <button
                            type="button"
                            className="btn-custom props-league-picks"
                            onClick={() => {
                                showModal(
                                    <PropsBetSlip
                                        setShowLimitAlert={setShowLimitAlert}
                                        setErrorMessage={setErrorMessage}
                                    />
                                );
                            }}
                        >
                            {bets.length} Pick(s)
                        </button>
                    )}
                </div>
                <div className="props-container">
                    {leagues.length === 0 ? (
                        <LeaguePropsTabsSkeleton />
                    ) : (
                        <div className="props-tabs props-league-tabs">
                            {leagues.map((item, i) => (
                                <div
                                    key={`${item.sport}-${item.league}`}
                                    className={`tab-props props-league-tab ${activeIndex === i ? "active" : ""}`}
                                    onClick={() => handleLeagueClick(item, i)}
                                >
                                    {item.name}
                                </div>
                            ))}
                        </div>
                    )}
                    {isLoading ? (
                        <LeaguePropsSkeleton />
                    ) : hasLoaded && fixtures.length === 0 ? (
                        <div className="no-data-games no-data-color ">
                            No games available for this league.
                        </div>
                    ) : (
                        fixtures.map(game => {
                            const { date, time } = formatDateTime(game.start_date);

                            return (
                                <Link key={game.id} className="no-link"
                                    to={
                                        `/home/props?` +
                                        `id=${encodeURIComponent(game.id)}` +
                                        `&league=${encodeURIComponent((game.league.id))}` +
                                        `&sport=${encodeURIComponent(game.sport.id)}` +
                                        `&home=${encodeURIComponent(game.home_competitors[0].name)}` +
                                        `&away=${encodeURIComponent(game.away_competitors[0].name)}` +
                                        `&homeLogo=${encodeURIComponent(game.home_competitors[0].logo)}` +
                                        `&awayLogo=${encodeURIComponent(game.away_competitors[0].logo)}` +
                                        `&gameId=${encodeURIComponent(game.game_id)}` +
                                        `&GameDate=${encodeURIComponent(game.start_date)}` +
                                        `&logoLeague=${encodeURIComponent(game.leagueLogo)}`
                                    }>
                                    <div className="props-league-content">
                                        <span className="league-props props-spacing">{game.away_team_display} @ {game.home_team_display}</span>
                                        <span className="league-props props-spacing2"> {date} {time}</span>
                                        <IoIosArrowForward className="arrow-props" />
                                    </div>
                                </Link>
                            );
                        })
                    )}
                </div>
            </div>
            {showLimitAlert && (
                <AlertError
                    message={errorMessage}
                    onClose={() => setShowLimitAlert(false)}
                />
            )}
        </div>
    )
}

export default LegueProps;
